import {
  MOTHERS_DAY_PATH,
  EASTER_PATH,
  WELCOME_GIFT_PATH,
  VALENTINE_EXPERIMENT,
  VALENTINE_START_DATE,
  VALENTINE_END_DATE,
  VALENTINE_DISCOUNT_PATH,
  VALENTINE_GIFT_CARD_PATH,
  SPRING_SALE_PATH,
  SPRING_SALE_START_DATE,
  SPRING_SALE_END_DATE,
  BLACK_FRIDAY_START_DATE,
  BLACK_FRIDAY_END_DATE,
  PROMOTION_PATH,
} from '../../../constants';

const resolveExperimentPath = (abCookie, experiment, paths) => {
  const variant = abCookie[experiment.id];
  return paths[variant] || paths.default;
};

export const getCampaignBanners = (abCookie = {}) => [
  {
    id: 'mothers-day',
    campaignPath: MOTHERS_DAY_PATH,
    campaignPaths: [MOTHERS_DAY_PATH],
    startDate: {
      default: new Date(Date.UTC(2025, 4, 6, 15, 15)),
    },
    endDate: {
      default: new Date(Date.UTC(2025, 4, 12, 22, 5)),
      us: new Date(Date.UTC(2025, 4, 13, 7, 5)),
    },
    text: {
      mini: 'Up to 50% off until May 12th!',
      small: "It's Mother's Day! Up to 50% off until May 12th!",
      medium: "It's Mother's Day! Up to 50% off your subscription until May 12th!",
    },
    priority: 1,
  },
  {
    id: 'easter',
    campaignPath: EASTER_PATH,
    campaignPaths: [EASTER_PATH],
    startDate: {
      default: new Date(Date.UTC(2025, 3, 10, 22, 5)),
    },
    endDate: {
      default: new Date(Date.UTC(2025, 4, 6, 15, 14)),
    },
    text: {
      mini: 'Celebrate Easter! Save up to 50%',
      small: 'Celebrate Easter with up to 50% off',
      medium: 'Celebrate Easter with up to 50% off on any subscription!',
    },
    altText: {
      after: new Date(2025, 3, 21),
      mini: 'Up to 50% off. Only until May 6!',
      small: 'Up to 50% off. Only until May 6!',
      medium: 'Up to 50% off on any subscription. Only until May 6!',
    },
    priority: 0,
  },
  {
    id: 'black-friday',
    campaignPath: 'black-friday/welcome',
    campaignPaths: ['black-friday/welcome'],
    startDate: {
      default: BLACK_FRIDAY_START_DATE,
    },
    endDate: {
      default: BLACK_FRIDAY_END_DATE,
    },
    text: {
      mini: 'Black Friday Special: Up to 50% OFF!',
      small: 'Black Friday Special: Up to 50% OFF! Explore Deals',
      medium: 'Black Friday Special: Up to 50% OFF! Explore Deals',
    },
    priority: 1,
  },
  {
    id: 'welcome-gift',
    campaignPath: WELCOME_GIFT_PATH,
    campaignPaths: [WELCOME_GIFT_PATH],
    startDate: {
      default: new Date(Date.UTC(2025, 9, 8)),
    },
    endDate: {
      default: new Date('2024-01-01'),
    },
    text: {
      mini: 'Exclusive welcome gift for you',
      small: 'Exclusive welcome gift for you',
      medium: 'Exclusive welcome gift for you: up to 60% off on any subscription!',
    },
    displayOnce: true,
    priority: 0,
  },
  {
    id: 'valentine',
    campaignPath: resolveExperimentPath(abCookie, VALENTINE_EXPERIMENT, {
      [VALENTINE_EXPERIMENT.variant.giftCard]: VALENTINE_GIFT_CARD_PATH,
      default: VALENTINE_DISCOUNT_PATH,
    }),
    campaignPaths: [VALENTINE_GIFT_CARD_PATH, VALENTINE_DISCOUNT_PATH],
    startDate: {
      default: VALENTINE_START_DATE,
    },
    endDate: {
      default: VALENTINE_END_DATE,
    },
    text: {
      mini:
        abCookie[VALENTINE_EXPERIMENT.id] === VALENTINE_EXPERIMENT.variant.discount
          ? 'A gift from Cupid — 2 months for free'
          : 'A gift from Cupid — up to 50% off',
      small:
        abCookie[VALENTINE_EXPERIMENT.id] === VALENTINE_EXPERIMENT.variant.discount
          ? 'A little love from Cupid — enjoy 2 months for free'
          : 'A little love from Cupid — enjoy up to 50% off',
      medium:
        abCookie[VALENTINE_EXPERIMENT.id] === VALENTINE_EXPERIMENT.variant.discount
          ? 'A little love from Cupid - enjoy 2 months for free on any subscription!'
          : 'A little love from Cupid — enjoy up to 50% off on any subscription!',
    },
    priority: 1,
  },
  {
    id: 'spring-sale',
    campaignPath: SPRING_SALE_PATH,
    campaignPaths: [SPRING_SALE_PATH],
    startDate: {
      default: SPRING_SALE_START_DATE,
    },
    endDate: {
      default: SPRING_SALE_END_DATE,
    },
    text: {
      mini: 'Spring into classical — up to 40% off!',
      small: 'Spring into classical — enjoy up to 40% off!',
      medium: 'Spring into classical — enjoy up to 40% off any subscription!',
    },
    priority: 1,
  },
  {
    id: 'promotions',
    campaignPath: PROMOTION_PATH,
    campaignPaths: [PROMOTION_PATH],
    startDate: {
      default: new Date(Date.UTC(2026, 6, 24, 7, 0, 0)),
    },
    endDate: {
      default: new Date(Date.UTC(2026, 9, 31, 23, 59, 59)),
    },
    text: {
      mini: 'Save Up to 40% This Week Only',
      small: 'Limited-Time Offer: Save Up to 40% This Week Only',
      medium: 'Limited-Time Offer: Save Up to 40% This Week Only. Explore Deals',
    },
    priority: 1,
  },
];

export const isBannerActive = (banner, basename) => {
  const now = new Date();
  const startDate =
    basename === 'us' && banner.startDate.us ? banner.startDate.us : banner.startDate.default;
  const endDate =
    basename === 'us' && banner.endDate.us ? banner.endDate.us : banner.endDate.default;

  return now >= startDate && now <= endDate;
};

export const getActiveBanners = (basename, abCookie) => {
  const activeBanners = getCampaignBanners(abCookie).filter(banner =>
    isBannerActive(banner, basename)
  );

  if (activeBanners.length === 0) {
    return [];
  }

  const maxPriority = Math.max(...activeBanners.map(b => b.priority));
  return activeBanners.filter(b => b.priority === maxPriority);
};

export const campaignPaths = getCampaignBanners().flatMap(banner => banner.campaignPaths);

export const getBannerText = banner => {
  if (banner.altText && new Date() >= banner.altText.after) {
    return {
      mini: banner.altText.mini,
      small: banner.altText.small,
      medium: banner.altText.medium,
    };
  }
  return banner.text;
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/campaignBannerConfig.js